(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7Osso", function(module, exports) {

$parcel$export(module.exports, "aniScroll", function () { return $5b0346e2b2b2d0d6$export$1a19be9ddcc0f28a; });
/**
 * Scroll-Based Animations
 *
 * Animate elements fluidly based on scroll position.
 *
 * Examples:
 *  aniScroll('.parallax-parent');
 *  // or
 *  aniScroll(document.querySelectorAll('.parallax-parent'));
 *  // or
 *  aniScroll([
 *      document.querySelector('.parallax-parent-1'),
 *      document.querySelector('.parallax-parent-2')
 *  ]);
 *
 * @param  {mixed}    mixed     Wrapper element (as selector string, nodelist, or array of nodes)
 * @param  {boolean}  viewport  False to use full element height (defualt) or true to use viewport height
 */ var $5b0346e2b2b2d0d6$export$1a19be9ddcc0f28a = function(mixed) {
    var viewport = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    // identify scroll-based animation elements
    var isStr = typeof mixed === 'string';
    var scrollWraps = isStr ? document.querySelectorAll(mixed) : mixed;
    // bail if we have nothing
    if (!scrollWraps.length) return;
    // prep to store all scroll-based animation elements
    var scrollable = {};
    // prep to store all all currently animating elements
    var scrollers = {};
    // animate things based on scroll position
    var animate = function() {
        // if we have elements that should animate (i.e. they're in the viewport)
        var keys = Object.keys(scrollers);
        if (keys.length) // animate each
        keys.forEach(function(key) {
            var item = scrollers[key];
            var win = window.innerHeight;
            var _item_getBoundingClientRect = item.getBoundingClientRect(), top = _item_getBoundingClientRect.top, height = _item_getBoundingClientRect.height;
            var per = viewport ? top / win : (top + height) / (win + height);
            // don't go out of bounds
            if (per < 0) per = 0;
            else if (per > 1) per = 1;
            scrollers[key].style.setProperty('--ani-plx', per);
        });
    };
    // create an observer so we can animate elements only when in view
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            // get the ID of this entry
            var id = entry.target.dataset.aniScroll;
            // if in view add to currently animating and identify as shown
            if (entry.isIntersecting) {
                scrollers[id] = scrollable[id];
                scrollable[id].classList.add('is-shown');
            // if not in view remove shown and delete from currently animating
            } else {
                scrollable[id].classList.remove('is-shown');
                delete scrollers[id];
            }
        });
    }, {
        rootMargin: '10px 0px 10px'
    });
    // controll scroll-based animations (throttled)
    var timer;
    window.addEventListener('scroll', function() {
        window.cancelAnimationFrame(timer);
        timer = window.requestAnimationFrame(animate);
    });
    // initialize animations
    scrollWraps.forEach(function(el, index) {
        // create a unique id for this element
        var id = "el".concat(index);
        el.dataset.aniScroll = id;
        // add this element to the list of scrollable things
        scrollable[id] = el;
        // add these to the observer so it can apply animations when they're in view
        observer.observe(el);
    });
    // trigger animations on initial script load
    animate();
    // reload on load to be certain image sizes e.g. are calculated
    window.addEventListener('load', animate);
    // reload on resize (debounced)
    var resizeTimer = null;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            animate();
        }, 300);
    });
};

});

/**
 * Parallax Sections JavaScript
 *
 * This file defines Parallax Sections
 * behavior.
 */ // import dependencies

var $7Osso = parcelRequire("7Osso");
var // add animations to all but last item
$c829caccf87aa4b6$var$_document_querySelectorAll;
($c829caccf87aa4b6$var$_document_querySelectorAll = document.querySelectorAll('.plxs__item')) === null || $c829caccf87aa4b6$var$_document_querySelectorAll === void 0 ? void 0 : $c829caccf87aa4b6$var$_document_querySelectorAll.forEach(function(el, i) {
    // skip first item so other things parallax under it
    if (i) // add class that we'll attach parallax animation to
    el.classList.add('ani--plxs');
});
// call it!
(0, $7Osso.aniScroll)('.ani--plxs', true);

})();
//# sourceMappingURL=plxs-script.js.map
